import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Dropdown } from 'react-bootstrap';

import {
  isGraphViewModified,
  isSystemGraphView,
  //isGraphViewUnsaved,
  resetGraphViewToDefault,
  generateNewGraphView,
  updateGraphView,
} from '@stores/graphViewPageSlice';

import { VIEW_ACTIONS } from '@awp/constants';
import SaveModal from './SaveModal';
import DeleteModal from './DeleteModal';

const GraphViewActions = () => {
  const [showSaveModal, setSaveModal] = useState(false);
  const [showDeleteModal, setDeleteModal] = useState(false);

  const currentGraphViewId = useSelector((state) => state.graphViewPage.graphViewId);
  const dispatch = useDispatch();

  const isModified = useSelector(isGraphViewModified);
  const isSystem = useSelector(isSystemGraphView);
  //const isUnsaved = useSelector(isGraphViewUnsaved) || false;

  const toggleSaveModal = () => {
    setSaveModal(!showSaveModal);
  };

  const toggleDeleteModal = () => {
    setDeleteModal(!showDeleteModal);
  };

  function handleSelect(value) {
    const payload = {
      graphViewId: currentGraphViewId,
    };

    if (value == VIEW_ACTIONS.DISCARD) {
      dispatch(resetGraphViewToDefault(payload));
    }

    if (value == VIEW_ACTIONS.ADD) {
      dispatch(generateNewGraphView());
    }

    if (value == VIEW_ACTIONS.SAVE_AS) {
      toggleSaveModal();
    }

    if (value == VIEW_ACTIONS.DELETE) {
      toggleDeleteModal();
    }

    if (value == VIEW_ACTIONS.SAVE) {
      dispatch(updateGraphView({ graphViewId: currentGraphViewId }));
      /*dispatch(fetchGraphViews());
			dispatch(setGraphViewId(currentGraphViewId));*/
    }
  }

  const Styles = {
    control: (styles) => ({
      ...styles,
      zIndex: '999',
      backgroundColor: 'white',
      borderColor: '#adb5bd',
      color: '#494949',
    }),
    dropdownIndicator: (styles) => ({ ...styles, '&:after': { display: 'none' } }),
  };

  return (
    <>
      <Dropdown onSelect={handleSelect} style={{ zIndex: '999' }}>
        <Dropdown.Toggle variant={'secondary'} className="graphView__actions">
          ...
        </Dropdown.Toggle>
        <Dropdown.Menu style={Styles} id="graphView-actions">
          <Dropdown.Item href="#" eventKey={VIEW_ACTIONS.ADD}>
            New View
          </Dropdown.Item>
          <Dropdown.Item
            eventKey={VIEW_ACTIONS.DELETE}
            disabled={isSystem || currentGraphViewId === null || currentGraphViewId < 0}
          >
            Delete View
          </Dropdown.Item>
          <Dropdown.Item eventKey={VIEW_ACTIONS.DISCARD} disabled={!isModified}>
            Discard Changes
          </Dropdown.Item>
          <Dropdown.Item
            eventKey={VIEW_ACTIONS.SAVE}
            disabled={isSystem || (!isSystem && !isModified) || currentGraphViewId === null || currentGraphViewId < 0}
          >
            Save
          </Dropdown.Item>
          <Dropdown.Item eventKey={VIEW_ACTIONS.SAVE_AS} disabled={currentGraphViewId === null}>
            Save As
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <SaveModal isOpen={showSaveModal} toggleModal={toggleSaveModal}></SaveModal>
      <DeleteModal isOpen={showDeleteModal} toggleModal={toggleDeleteModal}></DeleteModal>
    </>
  );
};

GraphViewActions.propTypes = {};

export default GraphViewActions;
